import type { BlogLocale } from "@/features/blog/locales";
import { BLOG_COPY } from "@/features/blog/copy";
import { blogIndexLink } from "@/features/blog/links";
import { Pill } from "@/landing/system/links";

export function Pagination({
  currentPage,
  totalPages,
  categorySlug,
  tagSlug,
  locale,
}: {
  currentPage: number;
  totalPages: number;
  categorySlug?: string;
  tagSlug?: string;
  locale: BlogLocale;
}) {
  if (totalPages <= 1) return null;

  return (
    <nav
      aria-label={BLOG_COPY[locale].pages}
      className="mt-12 flex flex-wrap gap-2"
    >
      {Array.from({ length: totalPages }, (_, idx) => idx + 1).map((page) => (
        <Pill
          key={page}
          {...blogIndexLink(locale)}
          search={{
            page: page === 1 ? undefined : page,
            category: categorySlug,
            tag: tagSlug,
          }}
          active={page === currentPage}
          className="w-9 px-0"
        >
          {page}
        </Pill>
      ))}
    </nav>
  );
}
